import Card from '../Card';
import ProjectCardProps from './ProjectCardProps';

export default function CreateSimpleProjectCard({
  project,
  className,
}: ProjectCardProps) {
  return (
    <Card key={project.id} project={project} className={className?.base}>
      <Card.Banner url={project.image} />
      <Card.Title title={project.title} />
      <Card.FlexGroup>
        <Card.PublushDate publishAt={project.createdAt} />
        <Card.Owners owners={project.users} />
      </Card.FlexGroup>
    </Card>
  );
}
